import React from 'react';
function ArrowWh({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.092 13.047v5.317h-5.316M6 5.25l13.092 13.114M10.567 4.434H5.25V9.75"
      />
    </svg>
  );
}

export default ArrowWh;
